<template>

  <v-container
    v-if="order"
    :style="{width: '100%', maxWidth: '960px'}"
    ref="parent"
    class="pa-2"
    fluid
  >

    <v-card class="ma-2" outlined>

      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            <v-icon x-small>mdi-account</v-icon>
            {{order.customer.first_name}} {{order.customer.last_name}}
          </v-col>
          <v-col cols="12">
            <v-icon x-small>mdi-email</v-icon>
            {{order.customer.email}}
          </v-col>
          <v-col cols="12">
            <v-icon x-small>mdi-phone</v-icon>
            {{order.customer.phone}}
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="mx-4"/>

      <v-card-text class="subtitle-1 font-weight-black">
        Rezervari
      </v-card-text>

      <div v-if="order && order.reservations">
        <im-reservation-card
          v-for="(reservation, index) in order.reservations"
          :key="`reservation_${index}`"
          :reservation="reservation"
        />
      </div>

    </v-card>


  </v-container>
</template>


<script>

  import order_repository from "@/repositories/order-repository";

  export default {

    components: {
      'im-reservation-card': () => import('@/components/Order/OrderReservationCard')
    },

    data: () => ({
      order: null,
    }),

    async created() {
      let order = this.$route.params.order;
      this.order = await order_repository.getOrder(order);
    }
  }

</script>